import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "./api";
import { useAdminAuth } from "./AdminApp";

export default function Login() {
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const { setAuth } = useAdminAuth();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/login", { password });
      setAuth(true);
      navigate("/admin/inquiries", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0c] text-white flex items-center justify-center px-4">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-sm rounded-3xl border border-white/10 bg-white/[0.03] p-8 backdrop-blur-xl"
      >
        <div className="mb-6 flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-white/5">
            <Lock size={18} />
          </span>
          <div>
            <p className="text-xs tracking-[0.2em] text-neutral-500">A FLAT RECORDS</p>
            <h1 className="font-heading text-lg font-semibold">Command Center</h1>
          </div>
        </div>
        <label className="mb-2 block text-xs uppercase tracking-widest text-neutral-500">
          Admin password
        </label>
        <input
          data-testid="admin-password-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoFocus
          className="w-full rounded-xl border border-white/10 bg-white/[0.04] px-4 py-3 text-white outline-none transition focus:border-white/40"
          placeholder="••••••••"
        />
        <button
          data-testid="admin-login-submit"
          disabled={busy}
          className="mt-5 flex w-full items-center justify-center gap-2 rounded-xl bg-white px-6 py-3.5 font-medium text-black transition hover:bg-neutral-200 disabled:opacity-60"
        >
          {busy ? <Loader2 size={18} className="animate-spin" /> : "Enter"}
        </button>
      </form>
    </div>
  );
}
